import {React, useEffect, useLayoutEffect} from 'react'
import "../components/GC_CTA_2.css";
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin();
gsap.registerPlugin(ScrollTrigger);


const GC_CTA_2 = () => {

    function handleClick()
    {
        document.querySelector('#conactAnchor').click();
     
    }

    useEffect(()=>
    {
        var magnets = document.querySelectorAll('.magnetic')
        var strength = 100

        function moveMagnet(event)
        {
            var magnetButton = event.currentTarget
            var bounding = magnetButton.getBoundingClientRect()

            //console.log(magnetButton, bounding)

            gsap.to( magnetButton, {
                x: ((( event.clientX - bounding.left)/magnetButton.offsetWidth) - 0.5) * strength,
                y: ((( event.clientY - bounding.top)/magnetButton.offsetHeight) - 0.5) * strength,
                ease: "power2.out"
            })
        }


        magnets.forEach( (magnet) => {
            magnet.addEventListener('mousemove', moveMagnet );
            magnet.addEventListener('mouseout', function(event)
            {
                gsap.to( event.currentTarget, 
                    {
                        x: 0, y: 0, ease: "power2.out"
                    })
            });
        });


    }, []);

  


return (
    <section className="cta-2" onClick={handleClick}>
        <div className="container">
            <div className="flex items-center">
                <div className='fs-100  gap-6 hidden md:flex'>
                    <div className="text-primary">Let's</div> <div className="build mr-10">build togather!</div>
                </div>

                <div className='fs-100  gap-6 flex md:hidden'>
                    <div className="text-primary">Let's <span className="build mr-10">build togather!</span></div>
                </div>
                <div className="magnetic">
                    <button aria-label="Open Menu" ><div className='text-transparent'>Let's Build togather</div></button>
                </div>
            </div>
            <div className="hh4">Great projects <span className="font-medium">start with collaboration.</span> </div>

            
            <div className="xl:w-1/2 mt-2 fs-24">
                <span className="opacity-70">Share your ideas with us, and let’s craft something innovative and impactful together.</span>
            </div>
            <div className=" block sm:hidden">
                <div className="mt-10 button-wrapper ">
                    <button ><div className='text-transparent'>Let's Build togather</div></button>
                </div>
            </div>
        </div>

    </section>
  )
}

export default GC_CTA_2
